import UserMenuContainer from 'components/UserMenu/UserMenuContainer'
import UserMenuPresentation from 'components/UserMenu/UserMenuPresentation'
import UserMenuData from 'components/UserMenu/UserMenuData'

export default {
  Container: UserMenuContainer,
  Presentation: UserMenuPresentation,
  Data: UserMenuData,
}
